module.exports = __webpack_public_path__ + "img/logo.bc4b2be5.png";